import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { appId, proctoringApiBaseUrl } from "config/constant";
import { AlvyEventState, ChatMessageRole } from "globals/enums";
import { RootState } from "store/store";

export interface SendMessagePayload {
  role_to: ChatMessageRole[];
  role: ChatMessageRole;
  text?: string;
  image_file?: string;
}

export interface InitializeAlvyChatPayload {
  step: string;
  candidate_instructions: string;
  state: AlvyEventState.Success;
  role: ChatMessageRole.System;
  role_to: [ChatMessageRole.Alvy];
}

export interface AlvyEventPayload {
  step: string;
  state: AlvyEventState;
  role: ChatMessageRole.System;
  role_to: [ChatMessageRole.Alvy];
  text?: string;
}

export const chatMessageApi = createApi({
  reducerPath: "chatMessage",
  baseQuery: retry(
    fetchBaseQuery({
      baseUrl: proctoringApiBaseUrl,
      prepareHeaders: (headers: Headers, { getState }) => {
        const sessionToken = (getState() as RootState).app.session.session_token;
        headers.set("app-id", appId as string);
        headers.set("session-token", sessionToken);
      }
    })
  ),
  endpoints: (builder) => ({
    sendMessage: builder.mutation({
      query: (payload: SendMessagePayload) => {
        return {
          url: "v1/message/send",
          method: "POST",
          body: payload
        };
      },
      extraOptions: { maxRetries: 3 }
    }),
    initializeAlvyChat: builder.mutation({
      query: (payload: InitializeAlvyChatPayload) => {
        return {
          url: "v1/message/send",
          method: "POST",
          body: payload
        };
      },
      extraOptions: { maxRetries: 3 }
    }),
    trackEventInAlvy: builder.mutation({
      query: (payload: AlvyEventPayload) => {
        return {
          url: "v1/message/send",
          method: "POST",
          body: payload
        };
      },
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useSendMessageMutation,
  useInitializeAlvyChatMutation,
  useTrackEventInAlvyMutation
} = chatMessageApi;
